import React from 'react'
import './ManPower.css'

const ManPower = ({ transporter_data }) => {
    const manpower = transporter_data?.manpower_details ?? 'Details not available'
    const hasDetails =
        manpower &&
        manpower !== 'Details not available' &&
        (manpower.management_staff || manpower.drivers || manpower.maintenance_staff)

    return (
        <div className="manpowercard">
            <div className="manpowercontainer">
                <span className="data_header">Manpower Details</span>
                {!hasDetails ? (
                    <div><b>Details not available</b></div>
                ) : (
                    <div>
                        <div className="manpowerDetails">{manpower.management_staff && <><b>Management Staff: </b> {manpower.management_staff}</>}</div>
                        <div className="manpowerDetails">{manpower.drivers && <><b>Drivers: </b> {manpower.drivers}</>}</div>
                        <div className="manpowerDetails">{manpower.maintenance_staff && <><b>Maintenance Staff: </b> {manpower.maintenance_staff}</>}</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ManPower
